'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/StarEmpty.tsx
var SvgStarEmpty = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.462 2.001a1.25 1.25 0 0 1 1.076 0c.284.136.447.374.54.526.096.156.195.357.299.568l2.2 4.456.011.024.026.004 4.92.719c.233.034.455.066.633.109.173.042.45.123.666.352.26.273.381.65.332 1.023-.041.312-.218.54-.333.676-.119.139-.28.295-.448.46l-3.56 3.466-.018.018.004.026.84 4.896c.04.232.078.453.092.635.014.178.023.467-.128.744-.18.33-.5.563-.87.632-.31.057-.582-.04-.746-.108-.169-.07-.368-.175-.576-.284l-4.399-2.313-.023-.013-.023.013-4.399 2.313c-.208.11-.407.214-.576.284-.164.068-.436.165-.746.108a1.25 1.25 0 0 1-.87-.633c-.15-.276-.142-.565-.128-.743.014-.181.052-.403.092-.635l.84-4.896.004-.026a5.183 5.183 0 0 1-.019-.018l-3.538-3.446a7.593 7.593 0 0 1-.469-.48c-.115-.135-.292-.364-.333-.676a1.25 1.25 0 0 1 .332-1.023c.216-.229.493-.31.666-.352.178-.043.4-.075.632-.11l.03-.003 4.89-.715.027-.004.011-.024 2.2-4.456a7.62 7.62 0 0 1 .299-.568c.093-.152.256-.39.54-.526ZM12 3.695a87.2 87.2 0 0 0-.045.09L9.77 8.215l-.015.03c-.05.102-.132.27-.26.41a1.25 1.25 0 0 1-.389.282c-.172.08-.357.106-.47.121l-.032.005-4.891.715-.1.014.072.071 3.538 3.446.023.023c.082.079.218.21.31.375.079.141.13.296.149.457a1.653 1.653 0 0 1-.036.518l-.835 4.867-.017.1.09-.047 4.373-2.3.028-.015c.1-.054.267-.142.452-.179.16-.03.323-.03.482 0 .186.037.351.125.452.179l.029.015 4.372 2.3.09.047-.017-.1-.835-4.867a1.655 1.655 0 0 1-.036-.517c.02-.162.07-.317.15-.458.091-.166.227-.296.309-.375l.023-.023 3.538-3.446.073-.07-.1-.015-4.892-.715a6.223 6.223 0 0 0-.032-.005 1.649 1.649 0 0 1-.47-.121 1.25 1.25 0 0 1-.389-.283 1.654 1.654 0 0 1-.26-.41l-.014-.029-2.187-4.43-.045-.09Z" }));
var StarEmpty_default = SvgStarEmpty;

module.exports = StarEmpty_default;
